// extracted by mini-css-extract-plugin
export var button = "header-module--button--IbbEP";
export var download = "header-module--download--cfm41";
export var footer = "header-module--footer--UhsX-";
export var label = "header-module--label--AKd1n";
export var logo = "header-module--logo--U6OGT";
export var main = "header-module--main--3dKjf";
export var subtitle = "header-module--subtitle--zFk2L";
export var svgD = "header-module--svgD--159iU";
export var svgM = "header-module--svgM--qnt74";
export var title = "header-module--title--LpeLU";
export var wrapper = "header-module--wrapper--whUPk";